// @index(['./!(*.spec).ts', './*/index.ts'], f => `export * from '${f.path.replace(/\/index$/, '')}';`)
export * from './customer-access-token.model';
export * from './customer-contact.model';
export * from './customer.model';
export * from './customer-site.model';
// @endindex